import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import Home from '../components/Home/Home';
import AppleStore from '../components/AppleStore/AppleStore';
import Marshall from '../components/Marshall/Marshall';
import marshallSpeakers from '../components/Marshall/PS-Items';
import SamsungStore from '../components/SamsungStore/SamsungStore';
import OnePlusStore from '../components/OnePlusStore/OnePlusStore';
import MarshallDetails from '../components/Marshall/MarshallDetails';
import MuvtechHome from '../components/Muvtech/MuvtechHome';
import ProductGrid from '../components/AppleStore/Iphone/ProductGrid';
import IphoneDetailPage from '../components/AppleStore/Iphone/IphoneDetailPage';
import MuvtechProductList from '../components/Muvtech/MuvtechProductList';
import MuvtechDetails from '../components/Muvtech/MuvtechDetails';
import AboutUs from '../components/About/AboutUs';
import ContactUs from '../components/Contact/ContactUs';
import Accessories from '../components/Accessories/Accessories';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: '/aboutus',
        element: <AboutUs />,
      },
      {
        path: '/contactus',
        element: <ContactUs />,
      },
      {
        path: '/samsungstore',
        element: <SamsungStore />,
      },
      {
        path: '/applestore',
        element: <AppleStore />,
      },
      {
        path: '/oneplusstore',
        element: <OnePlusStore />,
      },
      {
        path: '/marshall',
        element: <Marshall />,
        loader: () => {
          return marshallSpeakers;
        },
      },
      {
        path: '/marshall/details/:type/:id', // Example of a nested route
        element: <MarshallDetails />,
      },
      {
        path: '/muvtech',
        element: <MuvtechHome />,
      },
      {
        path: '/muvtech/products-list/:type',
        element: <MuvtechProductList />,
      },
      {
        path: '/muvtech/products-list/details/:type/:id',
        element: <MuvtechDetails />,
      },
      {
        path: '/applestore/products-list/:type',
        element: <ProductGrid />,
      },
      {
        path: '/applestore/iphone-products-list/iphone-detail-page/:type/:id',
        element: <IphoneDetailPage />,
      },
      {
        path: '/oneplusstore/products-list/:type',
        element: <ProductGrid />,
      },
      {
        path: '/oneplusstore/products-list/product-detail/:type/:id',
        element: <IphoneDetailPage />,
      },
      {
        path: 'accessories',
        element: <Accessories />,
      }
    ],
  },
]);

export default router;
